import { ReceiverService } from "@/common/api.service";
import {
  GET_ALLBENEFICIARY_LIST,
  UPDATE_BENEFICIARY,
  GET_BENEFICIARY_DETAILS,
  GET_BENEFICIARY_RELATIONSHIPS,
  GET_LINKED_REMITTERS,
} from "./actions.type";
import { SET_ERROR, ISLOADING } from "./mutations.type";
const state = {
  errors: null,
};

const getters = {
  //
};

const actions = {
  // get beneficiary-list
  async [GET_ALLBENEFICIARY_LIST](context, payload) {
    ReceiverService.init();
    ReceiverService.setHeader();
    context.commit(ISLOADING, true);
    return new Promise((resolve) => {
      ReceiverService.get(`beneficiary/listing/${payload}`)
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
    });
  },
  // get beneficiary/relationships
  async [GET_BENEFICIARY_RELATIONSHIPS](context) {
    ReceiverService.init();
    ReceiverService.setHeader();
    const data = await ReceiverService.get("beneficiary/relationships");
    context.commit(ISLOADING, false);
    return data;
  },

  // get linked remitters
  async [GET_LINKED_REMITTERS](context, payload) {
    ReceiverService.init();
    ReceiverService.setHeader();
    context.commit(ISLOADING, true);
    return new Promise((resolve) => {
      ReceiverService.get(
        `beneficiary/remitterList/${payload.beneficiaryid}/${payload.query}`,
      )
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
    });
  },
  // get beneficiary basic details
  async [GET_BENEFICIARY_DETAILS](context, payload) {
    ReceiverService.init();
    ReceiverService.setHeader();
    return new Promise((resolve) => {
      ReceiverService.get(
        `beneficiary/basicInfo/${payload.beneficiary_id}/${payload.customer_id}`,
      )
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
    });
  },
  // update beneficiary basic details
  async [UPDATE_BENEFICIARY](context, payload) {
    ReceiverService.init();
    ReceiverService.setHeader();
    context.commit(ISLOADING, true);
    return new Promise((resolve) => {
      ReceiverService.put(
        `beneficiary/basicInfo/${payload.beneficiary_id}/${payload.customer_id}`,
        payload,
      )
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
    });
  },
};
const mutations = {
  [SET_ERROR](state, error) {
    state.errors = error;
  },
  [ISLOADING](state, loading) {
    state.isLoading = loading;
  },
};
export default {
  state,
  getters,
  actions,
  mutations,
};
